module.exports = __webpack_public_path__ + "static/img/mep.56a9fb60.jpg";